"use client";

import { useState, useCallback } from "react";
import Image from "next/image";
import { ImageIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export function HuntImageThumbnail({
  src,
  alt,
  objectFit = "contain",
}: {
  src: string;
  alt: string;
  objectFit?: "cover" | "contain";
}) {
  const [loaded, setLoaded] = useState(false);
  const handleLoad = useCallback(() => setLoaded(true), []);

  return (
    <div className="relative aspect-square w-full overflow-hidden rounded-xl border bg-muted">
      {!loaded && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="absolute inset-0 animate-pulse bg-muted" />
          <ImageIcon className="relative h-6 w-6 text-muted-foreground/40" />
        </div>
      )}
      <Image
        src={src}
        alt={alt}
        fill
        sizes="(min-width: 768px) 20vw, 40vw"
        className={cn(
          objectFit === "cover" ? "object-cover" : "object-contain",
          "transition-opacity duration-300",
          loaded ? "opacity-100" : "opacity-0",
        )}
        onLoad={handleLoad}
      />
    </div>
  );
}
